import { render, staticRenderFns } from "./BookQuickPreviewHost.vue?vue&type=template&id=23839fcd&scoped=true&"
import script from "./BookQuickPreviewHost.vue?vue&type=script&lang=js&"
export * from "./BookQuickPreviewHost.vue?vue&type=script&lang=js&"
import style0 from "./BookQuickPreviewHost.vue?vue&type=style&index=0&id=23839fcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23839fcd",
  null
  
)

export default component.exports